var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5801 4.42023C14.1314 2.97147 11.702 2.97147 10.2532 4.42023L8.92259 5.75087C8.59716 6.07631 8.06952 6.07631 7.74408 5.75087C7.41865 5.42544 7.41865 4.8978 7.74408 4.57236L9.07473 3.24172C11.1744 1.14208 14.659 1.14208 16.7586 3.24172C18.8582 5.34135 18.8582 8.82597 16.7586 10.9256L15.428 12.2562C15.1025 12.5817 14.5749 12.5817 14.2495 12.2562C13.924 11.9308 13.924 11.4032 14.2495 11.0777L15.5801 9.74709C17.0289 8.29834 17.0289 5.86898 15.5801 4.42023ZM13.0893 6.91107C13.4147 7.23651 13.4147 7.76415 13.0893 8.08958L8.08926 13.0896C7.76382 13.415 7.23619 13.415 6.91075 13.0896C6.58531 12.7641 6.58531 12.2365 6.91075 11.9111L11.9108 6.91107C12.2362 6.58563 12.7638 6.58563 13.0893 6.91107ZM5.75055 7.7444C6.07599 8.06984 6.07599 8.59748 5.75055 8.92291L4.41991 10.2536C2.97115 11.7023 2.97115 14.1317 4.41991 15.5804C5.86866 17.0292 8.29802 17.0292 9.74677 15.5804L11.0774 14.2498C11.4029 13.9243 11.9305 13.9243 12.2559 14.2498C12.5814 14.5752 12.5814 15.1029 12.2559 15.4283L10.9253 16.7589C8.82565 18.8586 5.34103 18.8586 3.24139 16.7589C1.14176 14.6593 1.14176 11.1747 3.24139 9.07505L4.57204 7.7444C4.89748 7.41897 5.42511 7.41897 5.75055 7.7444Z",
    fill: "#505054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/icon_attach.edee7418755bbbc3de48a93c2f031462.svg";
export { ForwardRef as ReactComponent };